import React, { Fragment } from "react"
import Section from "@components/section"
import Title from "@components/title"
import classnames from "@utils/classnames"
import styles from "./stageEvents.module.scss"

import comingsoonImg from '@images/stage.png'

const mainDay1 = [
  ["10: 00", "活动活动"],
  ["10: 00", "活动活动"],
  ["10: 00", "活动活动"],
  ["10: 00", "活动活动"],
  ["10: 00", "活动活动"],
  ["10: 00", "活动活动"],
]

const renderDay = (day, date, table) => {
  return (
    <div className={styles.day}>
      <h3>
        <span>{day}</span>
        <span>{date}</span>
      </h3>
      <dl>
        {table.map(([time, detail]) => {
          return (
            <Fragment key={time}>
              <dt>{time}</dt>
              <dd>{detail}</dd>
            </Fragment>
          )
        })}
      </dl>
    </div>
  )
}

const StageEvents = React.memo(props => {
  return (
    <Section id="block-stage">
      <Title en="STAGE EVENTS">两个舞台，双倍快乐</Title>
      <img className={styles.comingsoon} src={comingsoonImg} alt="coming soon" />
      {/* <div className={styles.stages}>
        <div>
          <img src={mainTitleImg} alt="主舞台" className="fluidImg" />
          {renderDay("DAY 1", "5月15日", mainDay1)}
          {renderDay("DAY 2", "5月16日", mainDay1)}
        </div>
        <div>
          <img src={kkskTitleImg} alt="主舞台" className="fluidImg" />
          {renderDay("DAY 1", "5月15日", mainDay1)}
          {renderDay("DAY 2", "5月16日", mainDay1)}
        </div>
      </div> */}
    </Section>
  )
})

StageEvents.displayName = "StageEvents"
export default StageEvents
